var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "main-back" },
    [
      _c("div", { staticClass: "row topmainrow" }, [
        _c(
          "div",
          { staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12" },
          [
            _c("div", { staticClass: "topmainlayer card" }, [
              _c("div", { staticClass: "main-user-title" }, [
                _vm._v(" " + _vm._s(_vm.userName) + " 님,"),
                _c("br"),
                _vm._v(" 안녕하세요"),
                _c("br"),
                _c("span", { staticClass: "main-user-title-m" }, [
                  _vm._v("Smart Work를 시작하세요"),
                ]),
              ]),
              _c("div", { staticClass: "main-weather" }, [
                !_vm.wheatherInfo.temp
                  ? _c(
                      "span",
                      { staticClass: "weather-icon2" },
                      [
                        _c("q-img", {
                          staticStyle: { width: "40px" },
                          attrs: { src: _vm.wheatherInfo.loading },
                        }),
                      ],
                      1
                    )
                  : _vm._e(),
                _vm.wheatherInfo.temp
                  ? _c(
                      "span",
                      { staticClass: "weather-icon q-mr-xs" },
                      [
                        _vm._v(_vm._s(_vm.wheatherInfo.temp) + " "),
                        _c("q-img", {
                          staticStyle: { width: "40px" },
                          attrs: { src: _vm.wheatherInfo.icon },
                        }),
                      ],
                      1
                    )
                  : _vm._e(),
                _vm.wheatherInfo.location
                  ? _c("span", { staticClass: "main-weather-location" }, [
                      _vm._v(_vm._s(_vm.wheatherInfo.location) + " "),
                    ])
                  : _vm._e(),
              ]),
            ]),
            _c("div", { staticClass: "row topmainbtns" }, [
              _c(
                "div",
                {
                  staticClass:
                    "col-xs-6 col-sm-6 col-md-3 col-lg-3 col-xl-3 topcarddiv",
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "maincard card",
                      on: {
                        click: function ($event) {
                          return _vm.goPage("/sop/swp/safeWorkPermit")
                        },
                      },
                    },
                    [_vm._m(0)]
                  ),
                ]
              ),
              _c(
                "div",
                {
                  staticClass:
                    "col-xs-6 col-sm-6 col-md-3 col-lg-3 col-xl-3 topcarddiv",
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "maincard card",
                      on: {
                        click: function ($event) {
                          return _vm.goPage("/sai/patrol/patrol")
                        },
                      },
                    },
                    [_vm._m(1)]
                  ),
                ]
              ),
              _c(
                "div",
                {
                  staticClass:
                    "col-xs-6 col-sm-6 col-md-3 col-lg-3 col-xl-3 topcarddiv",
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "maincard card",
                      on: {
                        click: function ($event) {
                          return _vm.goPage("/sop/ibm/impr")
                        },
                      },
                    },
                    [_vm._m(2)]
                  ),
                ]
              ),
              _c(
                "div",
                {
                  staticClass:
                    "col-xs-6 col-sm-6 col-md-3 col-lg-3 col-xl-3 topcarddiv",
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "maincard card",
                      on: {
                        click: function ($event) {
                          return _vm.goPage("/sai/tbm/tbm")
                        },
                      },
                    },
                    [_vm._m(3)]
                  ),
                ]
              ),
              _c(
                "div",
                {
                  staticClass:
                    "col-xs-6 col-sm-6 col-md-3 col-lg-3 col-xl-3 topcarddiv",
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "maincard card",
                      on: {
                        click: function ($event) {
                          return _vm.goPage("/hea/jss/jobStressAssessment")
                        },
                      },
                    },
                    [_vm._m(4)]
                  ),
                ]
              ),
              _c(
                "div",
                {
                  staticClass:
                    "col-xs-6 col-sm-6 col-md-3 col-lg-3 col-xl-3 topcarddiv",
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "maincard card",
                      on: {
                        click: function ($event) {
                          return _vm.goPage("/sop/edu/result/educationResult")
                        },
                      },
                    },
                    [_vm._m(5)]
                  ),
                ]
              ),
              _c(
                "div",
                {
                  staticClass:
                    "col-xs-6 col-sm-6 col-md-3 col-lg-3 col-xl-3 topcarddiv",
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "maincard card",
                      on: {
                        click: function ($event) {
                          return _vm.goPage("/fft/fireFightingMaster")
                        },
                      },
                    },
                    [_vm._m(6)]
                  ),
                ]
              ),
              _c(
                "div",
                {
                  staticClass:
                    "col-xs-6 col-sm-6 col-md-3 col-lg-3 col-xl-3 topcarddiv",
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "maincard card",
                      on: {
                        click: function ($event) {
                          return _vm.goPage("/fft/ise/fireFightingIssueCheck")
                        },
                      },
                    },
                    [_vm._m(7)]
                  ),
                ]
              ),
              _c("div", { staticClass: "col-12 topcarddiv" }, [
                _c("div", { staticClass: "card noti-cardcontents" }, [
                  _c(
                    "div",
                    {
                      staticClass: "card-header",
                      staticStyle: {
                        "border-radius": "0.4375rem 0.4375rem 0 0",
                      },
                    },
                    [_vm._v(" 공지사항 ")]
                  ),
                  _c(
                    "div",
                    { staticClass: "card-body no-padding-card" },
                    [
                      _c("q-table", {
                        attrs: {
                          grid: "",
                          title: "",
                          data: _vm.data.noticeList,
                          "hide-header": "",
                          "hide-bottom": "",
                          "rows-per-page-options": [0],
                          "virtual-scroll": "",
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "item",
                            fn: function (props) {
                              return [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "col-xs-12 col-sm-12 col-md-6 col-lg-4 col-xl-3",
                                  },
                                  [
                                    _c(
                                      "q-card",
                                      {
                                        staticClass:
                                          "mobileTableCardLayer-main",
                                        on: {
                                          click: function ($event) {
                                            return _vm.getDetailPage(
                                              "NOTICE",
                                              props.row
                                            )
                                          },
                                        },
                                      },
                                      [
                                        _c(
                                          "q-card-section",
                                          { staticClass: "grid-card-etc" },
                                          [
                                            _c(
                                              "div",
                                              {
                                                class: [
                                                  "text-grid-etc",
                                                  _vm.getColorStatus3(
                                                    props.row.noticeClassCd
                                                  ),
                                                ],
                                              },
                                              [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      props.row.noticeClassName
                                                    ) +
                                                    " "
                                                ),
                                              ]
                                            ),
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "text-grid-title q-mt-sm q-mb-xs",
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(props.row.noticeTitle)
                                                ),
                                              ]
                                            ),
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "text-grid-etc-right",
                                              },
                                              [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(props.row.regDtStr) +
                                                    " "
                                                ),
                                              ]
                                            ),
                                          ]
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ]
                            },
                          },
                        ]),
                      }),
                      _vm.data.noticeList.length === 0
                        ? _c(
                            "div",
                            {
                              staticClass:
                                "col-xs-12 col-sm-12 col-md-6 col-lg-4 col-xl-3",
                            },
                            [
                              _c(
                                "q-card",
                                { staticClass: "mobileTableCardLayer-main" },
                                [
                                  _c(
                                    "q-card-section",
                                    {
                                      staticClass: "text-center",
                                      attrs: { horizontal: "" },
                                    },
                                    [
                                      _c(
                                        "q-card-section",
                                        { staticClass: "q-pt-xs" },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "text-grid-title text-grid-titlemain q-mt-sm q-mb-xs",
                                            },
                                            [
                                              _vm._v(
                                                "등록된 공지사항이 없습니다."
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                ]),
              ]),
            ]),
          ]
        ),
      ]),
      _c("c-dialog", { attrs: { param: _vm.popupOptions } }),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "card-body" }, [
      _c("div", { staticClass: "main-card-body-left" }, [
        _c("h4", { staticClass: "title" }, [_vm._v("안전작업허가서")]),
        _c("p", { staticClass: "subs" }, [_vm._v("일반/화기")]),
      ]),
      _c("div", { staticClass: "main-card-body-right animated fadeIn" }, [
        _c("i", { staticClass: "material-icons text-red-6" }, [
          _vm._v("home_repair_service"),
        ]),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "card-body" }, [
      _c("div", { staticClass: "main-card-body-left" }, [
        _c("h4", { staticClass: "title" }, [_vm._v("관리책임자패트롤")]),
        _c("p", { staticClass: "subs" }, [_vm._v("Patrol")]),
      ]),
      _c("div", { staticClass: "main-card-body-right animated fadeIn" }, [
        _c("i", { staticClass: "material-icons text-green-6" }, [
          _vm._v("change_circle"),
        ]),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "card-body" }, [
      _c("div", { staticClass: "main-card-body-left" }, [
        _c("h4", { staticClass: "title" }, [_vm._v("개선관리")]),
        _c("p", { staticClass: "subs" }, [_vm._v("시정조치")]),
      ]),
      _c("div", { staticClass: "main-card-body-right animated fadeIn" }, [
        _c("i", { staticClass: "material-icons text-indigo-6" }, [
          _vm._v("construction"),
        ]),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "card-body" }, [
      _c("div", { staticClass: "main-card-body-left" }, [
        _c("h4", { staticClass: "title" }, [_vm._v("ToolBoxMeeting")]),
        _c("p", { staticClass: "subs" }, [_vm._v("TBM")]),
      ]),
      _c("div", { staticClass: "main-card-body-right animated fadeIn" }, [
        _c("i", { staticClass: "material-icons text-deep-orange-6" }, [
          _vm._v("calendar_today"),
        ]),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "card-body" }, [
      _c("div", { staticClass: "main-card-body-left" }, [
        _c("h4", { staticClass: "title" }, [_vm._v("직무 스트레스")]),
        _c("p", { staticClass: "subs" }, [_vm._v("Stress")]),
      ]),
      _c("div", { staticClass: "main-card-body-right animated fadeIn" }, [
        _c("i", { staticClass: "material-icons text-yellow-9" }, [
          _vm._v("health_and_safety"),
        ]),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "card-body" }, [
      _c("div", { staticClass: "main-card-body-left" }, [
        _c("h4", { staticClass: "title" }, [_vm._v("교육")]),
        _c("p", { staticClass: "subs" }, [_vm._v("근로자 교육")]),
      ]),
      _c("div", { staticClass: "main-card-body-right animated fadeIn" }, [
        _c("i", { staticClass: "material-icons text-light-blue-6" }, [
          _vm._v("school"),
        ]),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "card-body" }, [
      _c("div", { staticClass: "main-card-body-left" }, [
        _c("h4", { staticClass: "title" }, [_vm._v("소방설비")]),
        _c("p", { staticClass: "subs" }, [_vm._v("Fire")]),
      ]),
      _c("div", { staticClass: "main-card-body-right animated fadeIn" }, [
        _c("i", { staticClass: "material-icons text-deep-purple-6" }, [
          _vm._v("fire_extinguisher"),
        ]),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "card-body" }, [
      _c("div", { staticClass: "main-card-body-left" }, [
        _c("h4", { staticClass: "title" }, [_vm._v("소방설비 이슈점검")]),
        _c("p", { staticClass: "subs" }, [_vm._v("Fire Check")]),
      ]),
      _c("div", { staticClass: "main-card-body-right animated fadeIn" }, [
        _c("i", { staticClass: "material-icons text-light-green-8" }, [
          _vm._v("local_fire_department"),
        ]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }